export default __webpack_public_path__ + "static/media/sample.a1167897.png";